// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 31) return "static/css/31.b246fb46e.chunk.css";
	// return url for filenames based on template
	return undefined;
};